<template>
  <v-container class="cmpbk_lght white--text" id="home-container">
    <!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
    <template>
      <div>
        <v-dialog v-model="show_imgfile_dialog" max-width="500px">
          <v-card
            class="cmpbk_drk white--text"
            style="border: 5px solid #1fdeb0 !important"
          >
            <!-- uplaod imag file -->
            <v-card-title dark class="headline"
              >Upload a Image File</v-card-title
            >
            <v-card-text dark>
              <p class="white--text">
                To upload an image file, please select the paperclip area below
                and then use the upload button. The file name will be prepended
                with a number on the server to preserve uniqueness.
              </p>
              <v-row class="">
                <v-col cols="12" md="12" lg="12" class="d-flex">
                  <v-file-input
                    class="white-text"
                    dark
                    v-if="showfileinput"
                    ref="fileInput"
                    id="fileimg"
                    show-size
                    accept=".png,.jpg, jpeg,"
                    label="File input"
                  ></v-file-input>
                  <v-btn
                    dark
                    class="accent black--text ml-1 mt-1"
                    style="position: relative; top: 10px"
                    @click="uploadfileimg"
                    >Upload</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="rgb(31, 222, 176)"
                text
                @click="show_imgfile_dialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>

    <template>
      <div>
        <v-dialog v-model="show_wavfile_dialog" max-width="500px">
          <v-card
            class="cmpbk_drk white--text"
            style="border: 5px solid #1fdeb0 !important"
          >
            <!-- uplaod wave file -->
            <v-card-title dark class="headline">Upload a Wav File</v-card-title>
            <v-card-text dark>
              <p class="white--text">
                To upload a wav file, please select the paperclip area below and
                then use the upload button. The maximum file size is 200 MB. The
                file name will be prepended with a number on the server to
                preserve uniqueness.
              </p>
              <v-row class="">
                <v-col cols="12" md="12" lg="12" class="d-flex">
                  <v-file-input
                    class="white-text"
                    dark
                    v-if="showfileinput"
                    ref="fileInput"
                    id="file"
                    show-size
                    accept=".wav,.m4a"
                    label="File input"
                  ></v-file-input>
                  <v-btn
                    dark
                    class="accent black--text ml-1 mt-1"
                    style="position: relative; top: 10px"
                    @click="uploadfile"
                    >Upload</v-btn
                  >
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="rgb(31, 222, 176)"
                text
                @click="show_wavfile_dialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <v-expansion-panels accordion v-model="panel" class="pa-1">
        <v-expansion-panel>
          <v-expansion-panel-header class="cmpbk_drk white--text"
            >Search</v-expansion-panel-header
          >
          <v-expansion-panel-content class="cmpbk_lght">
            <v-card class="cmpbk_drk white--text mt-4">
              <v-card-text>
                <template>
                  <v-row
                    ><v-col cols="12">
                      <h3 class="white--text">
                        Please select a Date Range, Title or News Text to search
                        by. Not selecting will return all records (this can take
                        some time).
                      </h3>
                    </v-col></v-row
                  >
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-date-picker
                        class="mt-2 ml-4 pa-2"
                        v-model="search_term.dates"
                        range
                        dark
                        color="cmpbk_lght"
                      ></v-date-picker>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        :value="dateRangeText"
                        label="Date range"
                        prepend-icon="mdi-calendar"
                        readonly
                        dark
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        class="ml-4"
                        label="Title"
                        v-model="search_term.title"
                        dark
                        placeholder="More Than 3 Chars."
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                      <v-text-field
                        class="ml-4"
                        label="News Text"
                        v-model="search_term.news_text"
                        dark
                        placeholder="More Than 3 Chars."
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-btn
                        dark
                        class="accent black--text ml-1 mt-1 cntrl_btm"
                        @click="search"
                      >
                        <v-icon small mr-1 title="Search">$magnify</v-icon>
                        Search
                      </v-btn>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel
          id="search_results"
          v-if="search_results.length > 0"
          class="whitesmoke"
        >
          <v-expansion-panel-header class="cmpbk_drk white--text"
            >Search Results</v-expansion-panel-header
          >
          <v-expansion-panel-content class="black">
            <v-card
              v-for="a_release in search_results"
              :key="a_release.releaseId"
              class="mb-4 mt-4"
              elevation="2"
              shaped
              dark
            >
              <v-card-text>
                <div
                  class="news-title d-flex flex-row justify-start align-start"
                >
                  <div class="news_title">{{ a_release.release_title }}</div>
                </div>

                <!-- row 1 -->
                <div
                  class="d-flex flex-row justify-start align-start flex-wrap"
                >
                  <div
                    class="afield_results d-flex flex-column justify-start align-start"
                  >
                    <label>Released:</label>
                    <article>{{ a_release.release_date }}</article>
                  </div>
                  <!-- <div
                    class="afield_results ml-4 d-flex flex-column justify-start align-start"
                  >
                    <label>Website:</label>
                    <article>{{ a_release.website }}</article>
                  </div> -->
                  <div
                    class="afield_results ml-4 d-flex flex-column justify-start align-start"
                  >
                    <label>Modified:</label>
                    <article>{{ a_release.s_date }}</article>
                  </div>
                  <div
                    class="afield_results created d-flex flex-column justify-start align-start ml-2"
                  >
                    <label>Created By:</label>
                    <article>{{ a_release.s_created }}</article>
                  </div>
                </div>
                <div
                  class="news-text mt-2"
                  v-html="a_release.release_text"
                ></div>
                <div>
                  <label>Media Only: {{ a_release.media_only }}</label>
                </div>

                <div>
                  <label>Wave file:&nbsp;</label>
                  <label
                    >{{ a_release.filename | ifnonestr }}
                    <v-icon
                      v-if="a_release.filename != null"
                      class="white--text"
                      style="cursor: pointer"
                      @click="delwave(a_release.wav_fileId)"
                      >$del</v-icon
                    ></label
                  >
                </div>
                <div>
                  <label class="">Img file:&nbsp;</label>
                  <label>
                    {{ a_release.filename_img | ifnonestr }}
                    <v-icon
                      v-if="a_release.filename_img != null"
                      class="white--text"
                      style="cursor: pointer"
                      @click="delimg(a_release.wav_fileId)"
                      >$del</v-icon
                    >
                  </label>
                </div>
              </v-card-text>
              <v-card-actions>
                <!-- Delete
Print
Release
Post to Website -->
                <div
                  class="d-flex flex-row justify-start align-start flex-wrap"
                >
                  <v-btn
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    @click="edit_show(a_release)"
                  >
                    <v-icon small mr-1 title="Edit Item">$edit</v-icon>
                    Edit
                  </v-btn>
                  <!-- <v-btn
                    @click="remove_release_dates(a_release)"
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Remove Dates Item"
                  >
                    <v-icon small mr-1>$del</v-icon>
                    Remove Dates
                  </v-btn> -->
                  <v-btn
                    @click="del_release_prompt(a_release)"
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Delete Item"
                  >
                    <v-icon small mr-1>$del</v-icon>
                    Del
                  </v-btn>
                  <v-btn
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Print Release"
                  >
                    <v-icon small mr-1>$print</v-icon>
                    Print
                  </v-btn>
                  <v-btn
                    v-if="a_release.release_date == '01/01/1900'"
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Notify and show Subscribers."
                    @click="release_now(a_release.news_releaseId)"
                  >
                    <v-icon small mr-1>$eye</v-icon>
                    Release {{ a_release.releaseId }}
                  </v-btn>
                  <v-btn
                    v-if="a_release.release_date != '01/01/1900'"
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Notify and show Subscribers."
                    @click="unrelease_now(a_release.news_releaseId)"
                  >
                    <v-icon small mr-1>$eyeoff</v-icon>
                    UN-Release {{ a_release.releaseId }}
                  </v-btn>
                  <!-- <v-btn
                    class="accent black--text ml-1 mt-1 cntrl_btm"
                    title="Post to Website"
                    @click="website_now(a_release.news_releaseId)"
                  >
                    <v-icon small mr-1>$web</v-icon>
                    Website
                  </v-btn> -->
                </div>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel class="cmpbk_drk">
          <v-expansion-panel-header class="cmpbk_drk white--text"
            >Recent</v-expansion-panel-header
          >
          <v-expansion-panel-content class="cmpbk_lght">
            <div class="mb-4 cmpbk_lght"></div>
            <p v-if="lst_releases.length == 0" class="white--text">
              There are no releases.
            </p>
            <v-card
              v-for="a_release in lst_releases"
              :key="a_release.releaseId"
              class="cmpbk_drk white--text mb-4"
              elevation="2"
              shaped
            >
              <v-card-text class="white--text">
                <v-container>
                  <v-row dense>
                    <v-col cols="12"
                      ><div class="news_title">
                        {{ a_release.release_title }}
                      </div></v-col
                    >
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <div class="d-flex flex-column justify-start align-start">
                        <label>Media Only: {{ a_release.media_only }}</label>
                        <!-- <v-checkbox
                          readonly
                          dark
                          v-model="a_release.media_only"
                          :label="'Media Only'"
                        ></v-checkbox> -->
                      </div>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col cols="12" md="4">
                      <div class="d-flex flex-column justify-start align-start">
                        <label>News Date:</label>
                        <article>{{ a_release.news_date }}</article>
                      </div>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div class="d-flex flex-column justify-start align-start">
                        <label>Modified:</label>
                        <article>{{ a_release.s_date }}</article>
                      </div>
                    </v-col>

                    <v-col cols="12" md="4">
                      <div class="d-flex flex-column justify-start align-start">
                        <label>Released:</label>
                        <article>{{ a_release.release_date | ifnone }}</article>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12" md="3">
                      <div class="d-flex flex-column justify-start align-start">
                        <label>Website:</label>
                        <article>{{ a_release.website_date | ifnone }}</article>
                      </div>
                    </v-col> -->
                  </v-row>

                  <div
                    class="news-text mt-2 pa-2"
                    style="height: auto; border: 1px solid white"
                    v-html="a_release.html_release_text"
                  ></div>
                  <div
                    class="afield created d-flex flex-column justify-start align-start"
                  >
                    <div>
                      <label>Wave file:&nbsp;</label>
                      <label
                        >{{ a_release.filename | ifnonestr }}
                        <v-icon
                          v-if="a_release.filename != null"
                          class="white--text"
                          style="cursor: pointer"
                          @click="delwave(a_release.wav_fileId)"
                          >$del</v-icon
                        ></label
                      >
                    </div>
                    <div>
                      <label class="">Img file:&nbsp;</label>
                      <label>
                        {{ a_release.filename_img | ifnonestr }}
                        <v-icon
                          v-if="a_release.filename_img != null"
                          style="cursor: pointer"
                          class="white--text"
                          @click="delimg(a_release.img_fileId)"
                          >$del</v-icon
                        >
                      </label>
                    </div>
                  </div>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <div
                  class="d-flex flex-row justify-start align-start flex-wrap"
                  style="width: 100%"
                >
                  <v-btn
                    class="accent black--text ml-1 mt-1 cntrl_btm show_btn hide-on-desktop"
                    @click="show_buttons(a_release)"
                  >
                    <v-icon small mr-1>$eye</v-icon>
                    Show Buttons
                  </v-btn>
                  <div class="hide-on-mobile" style="width: 100%">
                    <v-btn
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      @click="edit_show(a_release)"
                    >
                      <v-icon small mr-1 title="Edit Item">$edit</v-icon>
                      Edit
                    </v-btn>

                    <v-btn
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Print Release"
                      @click="print(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$print</v-icon>
                      Print
                    </v-btn>
                    <v-btn
                      v-if="a_release.release_date == '01/01/1900'"
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Notify and show Subscribers."
                      @click="release_now(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$eye</v-icon>
                      Release
                    </v-btn>
                    <v-btn
                      v-if="a_release.release_date !== '01/01/1900'"
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Notify and show Subscribers."
                      @click="unrelease_now(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$eyeoff</v-icon>
                      UN-Release
                    </v-btn>
                    <!-- <v-btn
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Post to Website"
                      @click="website_now(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$web</v-icon>
                      Website
                    </v-btn> -->
                    <v-btn
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Upload"
                      @click="show_upload_diag(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$save</v-icon>
                      Upload
                    </v-btn>
                    <v-btn
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Post to Website"
                      @click="show_wav_dialog(a_release.news_releaseId)"
                    >
                      <v-icon small mr-1>$play</v-icon>
                      Audio
                    </v-btn>
                    <!-- <v-btn
                      @click="remove_release_dates(a_release)"
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Remove Dates Item"
                    >
                      <v-icon small mr-1>$eyeoff</v-icon>
                      Remove Dates
                    </v-btn> -->
                    <v-btn
                      @click="del_release_prompt(a_release)"
                      class="accent black--text ml-1 mt-1 cntrl_btm"
                      title="Delete Item"
                    >
                      <v-icon small mr-1>$del</v-icon>
                      Del
                    </v-btn>
                  </div>
                </div>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <div id="fabhost">
      <v-btn
        class="black--text"
        @click="add_realease"
        elevation="4"
        color="accent"
        fab
        top
        right
        absolute
        style="top: -60px"
      >
        <v-icon class="black--text font-weight-bold">$plus</v-icon></v-btn
      >
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";
strong,
b {
  font-weight: 800;
}
.check {
  width: 100%;
  height: 35px;
  text-align: center;
}
.v-input :deep .theme--light.v-label {
  color: black !important;
}
.rounded {
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
}
strong {
  font-weight: 800;
  color: red;
}
p strong {
  font-weight: 800;
  color: red;
}
p {
  font-weight: 800;
  color: red;
}
.hide-on-mobile {
  display: none;
}
.cntrl_btm {
  width: 100%;
}
.news_title {
  font-size: 1.2rem;
  font-weight: 600;
}

*
  :deep(.theme--light.v-expansion-panels
    .v-expansion-panel-header
    .v-expansion-panel-header__icon
    .v-icon) {
  color: #ffffff;
}
#fabhost {
  width: 100%;
  position: fixed;
  bottom: 16px;
  right: 16px;
  z-index: 1000; /* Ensure it appears above other elements */
}
.afield label {
  font-weight: 600;
}
.afield article {
  font-size: 1.1rem;
  margin-left: 16px;
}
.afield_results label {
  font-weight: 600;
}
.afield_results article {
  font-size: 1.1rem;
}
.news-title {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 5px;
}
.news-text {
  outline: 1px;
  font-family: "proxima-nova";
  font-weight: 600;
}
@media (min-width: 768px) {
  .hide-on-mobile {
    display: block;
  }
  .hide-on-desktop {
    display: none;
  }
  .afield .created {
    margin-left: 16px;
    margin-top: 4px;
  }
  .cntrl_btm {
    width: auto;
  }
  .check {
    width: 126px;
  }
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "releases",
  mixins: [bus_common],
  data() {
    return {
      img_id_for_file: 0,
      wav_id_for_file: 0,
      showfileinput: true,
      show_wavfile_dialog: false,
      show_imgfile_dialog: false,
      dialog: false,
      search_term: {
        dates: "",
        title: "",
        news_text: "",
      },
      search_results: [],
      lst_releases: [],
      panel: 1,
      new_release: {
        releaseId: 0,
        released: "",
        website: "",
        s_created: "",
        s_date: "",
        news_date: "",
        news_title: "",
        news_text: "",
        media_only: false,
      },
    };
  },
  computed: {
    dateRangeText() {
      if (this.search_term.dates.length === 2) {
        return (
          this.format_date_us(this.search_term.dates[0].toString()) +
          " ~ " +
          this.format_date_us(this.search_term.dates[1].toString())
        );
      }
      return "";
    },
  },
  watch: {
    // "$store.state.lst_releases": function () {
    //   console.log("update");
    //   this.lst_releases = this.mno(this.$store.state.lst_releases);
    // },
  },
  filters: {
    ifnone(value) {
      if (value == "01/01/1900") {
        return "None";
      } else {
        return value;
      }
    },
    ifnonestr(value) {
      if (value == "" || value == null) {
        return "None";
      } else {
        return value;
      }
    },
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
    getFirst200Characters: function (inputString) {
      // Check if the input string is less than or equal to 60 characters

      if (inputString.length <= 200) {
        return inputString;
      }
      // Return the first 30 characters
      return inputString.substring(0, 200);
    },
  },
  methods: {
    delimg(id) {
      console.log("delimg");

      this.show_loader(true);
      let formIn = {};
      formIn.img_fileId = id;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "delimg";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    delwave(id) {
      console.log("delimg");

      this.show_loader(true);
      let formIn = {};
      formIn.wav_fileId = id;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "delwave";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    //uploadfileimg
    uploadfileimg() {
      console.log("empty: " + document.getElementById("fileimg").files[0]);
      if (document.getElementById("fileimg").files[0] == undefined) {
        this.swall_it(
          "Upload Status",
          "Please select a file before uploading.",
          "warning",
          null,
          null
        );
        return true;
      }
      console.log("file email: " + this.$store.state.user.email);
      const formData = new FormData();
      formData.append("file", document.getElementById("fileimg").files[0]);
      formData.append("id", this.img_id_for_file);
      formData.append("email", this.$store.state.user.email);

      var self = this;
      this.showfileinput = false;

      this.$store
        .dispatch("uploadfileimg", formData)
        .then((data) => {
          console.log("upload file");
          self.showfileinput = true;

          self.swall_it(
            "Upload Status",
            data + " uploaded",
            "success",
            null,
            null
          );
          self.getInitRecent();
          self.show_imgfile_dialog = false;
        })
        .catch((msg) => {
          this.show_loader(false);
          self.mrbreakpoint("err");
          console.log(msg);
          // this.swall_it("Error Fetching Expended", msg, "error", null, null);
        });
    },
    show_upload_diag(id) {
      this.img_id_for_file = id;
      this.show_imgfile_dialog = true;
    },
    uploadfile() {
      console.log("empty: " + document.getElementById("file").files[0]);
      if (document.getElementById("file").files[0] == undefined) {
        this.swall_it(
          "Upload Status",
          "Please select a file before uploading.",
          "warning",
          null,
          null
        );
        return true;
      }
      console.log("file email: " + this.$store.state.user.email);
      const formData = new FormData();
      formData.append("file", document.getElementById("file").files[0]);
      formData.append("id", this.wav_id_for_file);
      formData.append("email", this.$store.state.user.email);

      var self = this;
      this.showfileinput = false;

      this.$store
        .dispatch("uploadfile", formData)
        .then((data) => {
          console.log("upload file");
          self.showfileinput = true;

          self.swall_it(
            "Upload Status",
            data + " uploaded",
            "success",
            null,
            null
          );
          self.getInitRecent();
          self.show_wavfile_dialog = false;
        })
        .catch((msg) => {
          this.show_loader(false);
          self.mrbreakpoint("err");
          console.log(msg);
          // this.swall_it("Error Fetching Expended", msg, "error", null, null);
        });
    },
    show_wav_dialog(id) {
      this.wav_id_for_file = id;
      this.show_wavfile_dialog = true;
    },
    show_buttons() {
      let lstbtn = document.querySelectorAll(".show_btn");
      lstbtn.forEach((element) => {
        element.style.display = "none";
      });
      lstbtn = document.querySelectorAll(".hide-on-mobile");
      lstbtn.forEach((element) => {
        element.classList.remove("hide-on-mobile");
      });
    },
    website_now(news_releaseId) {
      console.log("website_now");

      this.show_loader(true);
      let formIn = {};

      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "website_now";
      formIn.news_releaseId = news_releaseId;
      let self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    //unrelease_now
    unrelease_now(news_releaseId) {
      console.log("release_now");

      this.show_loader(true);
      let formIn = {};

      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "unrelease_now";
      formIn.news_releaseId = news_releaseId;
      let self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    release_now(news_releaseId) {
      console.log("release_now");

      this.show_loader(true);
      let formIn = {};

      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "release_now";
      formIn.news_releaseId = news_releaseId;
      let self = this;

      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    print(id) {
      this.mrbreakpoint("id");
      var fuaxid = this.prependRandomNumber(id);
      console.log("/print/?news_releaseId=" + fuaxid.toString());
      window.open("/print/?news_releaseId=" + fuaxid.toString(), "_blank");
    },
    //
    remove_release_dates(a_release) {
      console.log("del_release");

      this.show_loader(true);
      let formIn = {};
      formIn.news_releaseId = a_release.news_releaseId;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "remove_release_dates";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    del_release_prompt(a_release) {
      let self = this;
      this.swall_diag(
        "Confirm Delete",
        "Release Titled '" +
          a_release.release_title +
          "' will be deleted. Continue?",
        "question",
        function () {
          self.del_release(a_release);
        },
        null,
        null,
        function () {}
      );
    },
    del_release(a_release) {
      console.log("del_release");

      this.show_loader(true);
      let formIn = {};
      formIn.news_releaseId = a_release.news_releaseId;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "del_release";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.getInitRecent();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    search() {
      console.log("search");

      if (this.search_term.title.length <= 3) {
        this.search_term.title = "";
      }
      if (this.search_term.news_text.length <= 3) {
        this.search_term.news_text = "";
      }
      this.show_loader(true);
      let formIn = {};
      formIn.search_term = this.search_term;
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "search";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.show_loader(false);

          if (data.length == 0) {
            this.swall_it(
              "Search",
              "Your search criteria did not yield results. Please enter new criteria and try again.",
              "warning",
              null,
              null
            );
            return true;
          }
          self.search_results = self.mno(data);
          self.search_results.forEach((element) => {
            element.release_date = self.format_date_us(element.release_date);
            element.s_date = self.format_date_us(element.s_date);
          });
          self.panel = 2;
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    fish(a_release) {
      console.log("fish");
      this.$store.commit("setReleasex", a_release);
      this.$router.push("/sinppet");
    },
    edit_show(a_release) {
      console.log("go");
      this.$store.commit("setReleasex", a_release);
      this.$router.push("/addedit");
    },
    add_realease() {
      this.$store.commit("setReleasex", this.new_release);
      this.$router.push("/addedit");
    },
    message1() {
      alert("This button does nothing yet.");
    },
    getInitRecent() {
      console.log("getInitRecent");

      this.show_loader(true);
      let formIn = {};
      //date is in sql format in local var
      formIn.token = this.$store.state.user.token;
      formIn.email = this.$store.state.user.email;
      formIn.apiname = "getInitRecent";
      let self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          self.lst_releases = self.mno(data);

          for (let index = 0; index < self.lst_releases.length; index++) {
            const element = self.lst_releases[index];
            element.s_date = self.format_date_us(element.s_date);
            element.s_CreateDate = self.format_date_us(element.s_CreateDate);
            element.news_date = self.format_date_us(element.news_date);
            element.release_date = self.format_date_us(element.release_date);
            element.website_date = self.format_date_us(element.website_date);
            console.log("release_date: " + element.release_date);
            element.html_release_text = self.getFirst200Characters(
              element.release_text
            );
          }
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },

    compareObjects(obj1, obj2) {
      const keys1 = Object.keys(obj1);
      const keys2 = Object.keys(obj2);

      if (keys1.length !== keys2.length) {
        return false;
      }

      for (let key of keys1) {
        if (obj1[key] !== obj2[key]) {
          return false;
        }
      }

      return true;
    },
    compareArrays(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false;
      }

      for (let i = 0; i < arr1.length; i++) {
        if (!compareObjects(arr1[i], arr2[i])) {
          return false;
        }
      }

      return true;
    },
    search_date_init() {
      let dtStr = this.format_date_sql(new Date());
      const dateRange = [
        dtStr, // Start date
        dtStr,
      ];
      return dateRange;
    },
    init() {
      console.log("init");
      this.search_term.dates = this.search_date_init();
      this.getInitRecent();
    },
  },
  updated() {
    // console.log("update");
    // this.lst_releases = this.mno(this.$store.state.lst_releases);
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
